export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[640px] flex items-center pt-[72px] overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-50 via-background-100/80 to-background-50"></div>
      <div className="absolute inset-0 opacity-[0.06] bg-[radial-gradient(ellipse_at_70%_30%,oklch(0.56_0.22_25)_0%,transparent_50%)]"></div>
      <div className="absolute inset-0 opacity-[0.04] bg-[radial-gradient(ellipse_at_30%_70%,oklch(0.65_0.18_80)_0%,transparent_50%)]"></div>

      <div className="relative w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16 max-w-[1280px] mx-auto">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/10 border border-primary-500/20 mb-5">
              <div className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-pulse"></div>
              <span className="text-xs text-primary-300 font-medium whitespace-nowrap">每日更新 · 高清流畅</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-50 font-heading leading-tight mb-4">
              成全影视
              <span className="block text-primary-400 lg:inline lg:ml-2">电视剧全集免费在线观看平台</span>
            </h1>

            <p className="text-lg md:text-xl text-accent-300 font-medium mb-6">
              不缓冲看剧，全集免费追，热门电视剧一网打尽
            </p>

            <p className="text-sm md:text-base text-foreground-400 leading-relaxed mb-8 max-w-[540px] mx-auto lg:mx-0">
              成全影视汇聚全网热门电视剧，每日更新最新剧集内容，覆盖古装玄幻、都市情感、悬疑推理等多元题材。全站免VIP免费在线观看，智能CDN加速确保播放零缓冲。无论你是深度剧迷还是休闲追剧，都能在这里找到属于你的那部好剧。当前暑期档专题已全面上线，百部热剧等你来追。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-foreground-50 whitespace-nowrap">50+</div>
                <div className="text-xs text-foreground-500 mt-1 whitespace-nowrap">每日更新剧集</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-foreground-50 whitespace-nowrap">10,000+</div>
                <div className="text-xs text-foreground-500 mt-1 whitespace-nowrap">热门电视剧</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-bold text-foreground-50 whitespace-nowrap">零缓冲</div>
                <div className="text-xs text-foreground-500 mt-1 whitespace-nowrap">免VIP畅看</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-foreground-50 font-medium rounded-lg transition-all cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始追剧
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-200 hover:bg-background-300 text-foreground-100 font-medium rounded-lg transition-all cursor-pointer whitespace-nowrap text-sm border border-background-300/60"
              >
                <i className="ri-fire-line text-lg"></i>
                热门排行
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[520px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-500/10 via-accent-500/5 to-transparent rounded-2xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20drama%20streaming%20platform%20hero%20visual%20with%20multiple%20floating%20drama%20poster%20cards%20featuring%20ancient%20and%20modern%20Chinese%20costumes%2C%20cinematic%20warm%20lighting%2C%20dark%20elegant%20background%2C%20professional%20entertainment%20banner%20design%2C%20film%20reel%20texture%2C%20subtle%20glow%20effects%2C%20premium%20streaming%20service%20aesthetic&width=800&height=600&seq=hero-main-visual&orientation=landscape"
                alt="成全影视 - 热门电视剧在线观看"
                className="relative w-full h-auto rounded-xl object-cover"
                title="成全影视 - 热门电视剧大全免费高清在线免VIP"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}